import React from "react";
import CartHeader from "./header";
import CartBody from "./body";
import { useSelector } from "react-redux";
import Loader from "components/loader";
import CartFooter from "./footer";

const Cart = () => {
	const { loading } = useSelector((state) => state.cart);

	return loading ? (
		<aside className="h-full flex flex-col items-center justify-center">
			<Loader ring />
		</aside>
	) : (
		<aside className="h-full flex flex-col">
			<CartHeader />
			<CartBody />
			<CartFooter />
		</aside>
	);
};

export default Cart;
